import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

// get auth state slice from the full state
const useDashboardInfo = () => useSelector((state: RootState) => state?.dashboardInfo || {});

export default useDashboardInfo;
